export function basicInfoLabel(row, field, t) {
  const keyField = `${field}Key`;
  if (row[keyField]) return t(row[keyField]);
  return row[field] ?? '';
}

export function basicInfoCols(t, options = {}) {
  const {
    width1 = '170',
    align1 = 'center',
    width3 = '170',
    align3 = 'center',
  } = options;

  return [
    {
      label: '',
      prop: 'name1',
      width: width1,
      align: align1,
      html: (row) => basicInfoLabel(row, 'name1', t),
    },
    { label: '', prop: 'name2', html: (row) => basicInfoLabel(row, 'name2', t) },
    {
      label: '',
      prop: 'name3',
      width: width3,
      align: align3,
      html: (row) => basicInfoLabel(row, 'name3', t),
    },
    { label: '', prop: 'name4', html: (row) => basicInfoLabel(row, 'name4', t) },
  ];
}

export const EDITABLE_BASIC_INFO_KEYS = ['t_vi3lpo', 't_mwvf0', 't_mwvfq', 't_h90vb'];

export function isEditableBasicInfoLabel(item, field) {
  const key = item[`${field}Key`];
  return key && EDITABLE_BASIC_INFO_KEYS.includes(key);
}
